module.exports = __webpack_public_path__ + "media/application/images/svgs/activity-8d618dcd88d63b512c93d6bb1b3b78ba.svg";